<template>
  <div>
    <template v-if="typePage === 'All'">
      <OrderLogistic ref="OrderLogisticViewComponent"/>
    </template>

    <router-view
        @allOrdersUpdater="allOrdersUpdater"
    ></router-view>
  </div>
</template>

<script>
import OrderLogistic from "@components/orders/OrderLogistic.vue";
export default {
  components: {
    OrderLogistic
  },

  data() {
    return {
      typePage: "",
      openOrder: false,
    };
  },

  methods:{
    allOrdersUpdater(index, id) {
      this.$refs.OrderLogisticViewComponent.updateOneOrder(index, id)
    },
  },
  beforeRouteEnter(to, _, next) {
    next((vm) => {
      if (!!to.params.id) {
        vm.typePage = "Detail";
      } else {
        vm.typePage = "All";
      }
    });
  },

  beforeRouteUpdate(to, _, next) {
    if (!!to.params.id === false) {
      this.typePage = "All";
    }
    next();
  },
};
</script>

<style></style>
